import React from 'react';

import {
  activityTemplates,
  routeDirectory
} from 'modules';
import {
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom';

import * as OrderListTable from './OrderListTable//OrderListTable';
import { ValidationState } from 'generated/graphql';



export const DataCacheActivity: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams<{
    // storeId: string;
    validationState: 'valid' | 'invalid' | 'notValidated' | 'invalidArchived';
  }>();

  const [searchParams] = useSearchParams();
  const storeId = searchParams.get('storeId');

  const handleSelectTab = React.useCallback(
    (tabId: ValidationState) => {
      navigate(routeDirectory.admin.dataCache.path(tabId, storeId), { replace: true });
    },
    [
      navigate,
      storeId
    ]
  );



  return (
    <activityTemplates.AdminActivityTemplate.FC>
      <OrderListTable.FC
        key={`${params.validationState}-${storeId}`}
        storeId={storeId}
        validationState={params.validationState ?? 'valid'}
        onSelectTab={handleSelectTab} />
    </activityTemplates.AdminActivityTemplate.FC>
  );
};
